export const L10N = {
  LABEL_SPANISH_RESIDENT: { id: 'core.label.spanish_resident' },
};
